import styled from "styled-components";
import { responsive } from "../../../../../../../../styles/constants.style";

export const SalesCreditDetailsWrapper = styled.div`
  padding: 48px 16px;

  ${responsive.MOBILE`
    padding: 16px 8px;
  `}
`;
